// Rebire base JS — no jQuery, no framework, no CDN. Vanilla only per theme audit findings.
// Motion obeys RULE-014: 150-400ms, fade/gentle-translate only, no bounce, no spin.

document.addEventListener('DOMContentLoaded', function () {
  /* ---------- Variant picker ---------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (group) {
    var scope = group.closest('.product-hero__info') || document;
    group.querySelectorAll('[data-variant-option]').forEach(function (button) {
      button.addEventListener('click', function () {
        group.querySelectorAll('[data-variant-option]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        button.setAttribute('aria-pressed', 'true');

        // The hidden id input lives in the product form, a sibling of the picker —
        // not inside the picker itself. Scope the lookup to the shared parent.
        scope.querySelectorAll('input[name="id"]').forEach(function (input) {
          input.value = button.getAttribute('data-variant-id');
        });
      });
    });
  });

  /* ---------- Scroll reveal ---------- */
  // IntersectionObserver rather than a scroll-linked animation library: no dependency,
  // and it can't jank the main thread. Content is visible by default in CSS and only
  // hidden once JS confirms it can reveal it, so a JS failure never blanks the page.
  var revealables = document.querySelectorAll('[data-reveal]');

  if (revealables.length && 'IntersectionObserver' in window) {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!prefersReducedMotion) {
      document.documentElement.classList.add('reveal-enabled');

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var delay = Number(entry.target.getAttribute('data-reveal-delay')) || 0;
            setTimeout(function () {
              entry.target.classList.add('is-revealed');
            }, delay);
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
      );

      revealables.forEach(function (el) {
        observer.observe(el);
      });
    }
  }

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('[data-accordion]').forEach(function (accordion) {
    var triggers = accordion.querySelectorAll('[data-accordion-trigger]');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        var wasOpen = trigger.getAttribute('aria-expanded') === 'true';

        // One question open at a time, per the FAQ component spec.
        triggers.forEach(function (other) {
          other.setAttribute('aria-expanded', 'false');
          var otherPanel = document.getElementById(other.getAttribute('aria-controls'));
          if (otherPanel) otherPanel.hidden = true;
        });

        if (!wasOpen && panel) {
          trigger.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      });
    });
  });

  /* ---------- Feature drawers ---------- */
  // Opened from the "+" on a feature card. The markup is already in the DOM —
  // this only toggles visibility — so the copy is present for crawlers and for
  // anyone whose JS never runs.
  //
  // `hidden` is removed a frame before `.is-open` is added: the panel has to be
  // laid out before the transform transition has anything to animate from,
  // otherwise it appears instantly instead of sliding.
  var openDrawer = null;
  var drawerOpener = null;

  function closeDrawer() {
    if (!openDrawer) return;
    var drawer = openDrawer;

    drawer.classList.remove('is-open');
    document.body.style.overflow = '';

    // Wait out the slide before hiding, so it does not vanish mid-transition.
    window.setTimeout(function () {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }, 320);

    if (drawerOpener) {
      drawerOpener.setAttribute('aria-expanded', 'false');
      // Return focus to the button that opened this, not the top of the page.
      drawerOpener.focus();
      drawerOpener = null;
    }

    openDrawer = null;
  }

  document.querySelectorAll('[data-drawer-open]').forEach(function (button) {
    button.addEventListener('click', function () {
      var drawer = document.getElementById(button.getAttribute('data-drawer-open'));
      if (!drawer) return;

      closeDrawer();

      openDrawer = drawer;
      drawerOpener = button;
      button.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';

      drawer.hidden = false;
      window.requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        var panel = drawer.querySelector('.drawer__panel');
        if (panel) panel.focus();
      });
    });
  });

  document.querySelectorAll('[data-drawer-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  /* ---------- Sticky add-to-cart (mobile) ---------- */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var heroCta = document.querySelector('.product-hero__cta');

  if (stickyBar && heroCta && 'IntersectionObserver' in window) {
    var ctaObserver = new IntersectionObserver(
      function (entries) {
        // Show the bar only once the hero CTA has scrolled out of view.
        stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
      },
      { threshold: 0 }
    );
    ctaObserver.observe(heroCta);
  }
});

/* ==========================================================================
   Component behaviour — Petit-derived homepage components (2026-07-26)

   A second listener rather than an edit into the first: these are independent
   components, and keeping them separate means a throw inside one block cannot
   take out the variant picker or the scroll reveal above it.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  /* ---------- Hotspots ----------
     The "+" markers over a scene. Unlike the drawer these do not trap focus or
     lock the body: the caption is two sentences, so a modal would be heavier
     than the content it carries. One open at a time, because two open captions
     over the same scene overlap each other. */

  var hotspots = Array.prototype.slice.call(document.querySelectorAll('[data-hotspot]'));

  /* Tells the stylesheet the markers are live, so the mobile text list — the
     no-JS fallback for the same content — can hide itself instead of repeating
     what the markers now say. Same pattern as reveal-enabled / sequence-enabled. */
  if (hotspots.length) document.documentElement.classList.add('hotspots-enabled');

  function closeHotspots(except) {
    hotspots.forEach(function (spot) {
      if (spot === except) return;
      spot.classList.remove('is-open');
      var toggle = spot.querySelector('.hotspot__toggle');
      var body = spot.querySelector('.hotspot__body');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      // Wait out the fade before hiding, or it disappears mid-transition.
      if (body) {
        window.setTimeout(function () {
          if (!spot.classList.contains('is-open')) body.hidden = true;
        }, 260);
      }
    });
  }

  hotspots.forEach(function (spot) {
    var toggle = spot.querySelector('.hotspot__toggle');
    var body = spot.querySelector('.hotspot__body');
    var closeBtn = spot.querySelector('[data-hotspot-close]');
    if (!toggle || !body) return;

    toggle.addEventListener('click', function () {
      var isOpen = spot.classList.contains('is-open');

      closeHotspots(isOpen ? null : spot);

      if (isOpen) {
        spot.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        window.setTimeout(function () {
          if (!spot.classList.contains('is-open')) body.hidden = true;
        }, 260);
        return;
      }

      // Laid out one frame before the class lands, so the transform has a
      // start value to animate from — same reason as the drawer above.
      body.hidden = false;
      window.requestAnimationFrame(function () {
        spot.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      });
    });

    // The mobile sheet has no other obvious dismissal — the marker that
    // opened it has usually scrolled out of view by the time the sheet is
    // read. An explicit close button, not just Escape or tapping outside.
    if (closeBtn) {
      closeBtn.addEventListener('click', function (event) {
        event.stopPropagation();
        closeHotspots(null);
      });
    }
  });

  if (hotspots.length) {
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeHotspots(null);
    });

    // Tapping anywhere outside an open sheet closes it — the sheet covers
    // the bottom of the screen with no obvious way out otherwise.
    document.addEventListener('click', function (event) {
      var openSpot = hotspots.filter(function (spot) {
        return spot.classList.contains('is-open');
      })[0];
      if (!openSpot) return;
      if (openSpot.contains(event.target)) return;
      closeHotspots(null);
    });
  }

  /* ---------- Rails ----------
     Scroll-snap carousels. The scrolling itself is CSS; this only keeps the
     dots in sync and lets a dot scroll the rail. Nothing here is required for
     the rail to work — with JS off it is still a swipeable overflow list, and
     the dots are simply inert. */

  document.querySelectorAll('[data-rail]').forEach(function (rail) {
    var dotsList = document.querySelector('[data-rail-dots="' + rail.getAttribute('data-rail') + '"]');
    var items = Array.prototype.slice.call(rail.children);
    if (!items.length) return;

    var dots = dotsList ? Array.prototype.slice.call(dotsList.querySelectorAll('.dots__dot')) : [];

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        var target = items[index];
        if (!target) return;
        // scrollIntoView would also scroll the page vertically to reach the
        // rail; scrollLeft touches only the rail.
        rail.scrollTo({
          left: target.offsetLeft - (rail.clientWidth - target.clientWidth) / 2,
          behavior: 'smooth'
        });
      });
    });

    function syncDots() {
      if (!dots.length) return;
      var center = rail.scrollLeft + rail.clientWidth / 2;
      var nearest = 0;
      var shortest = Infinity;

      items.forEach(function (item, index) {
        var distance = Math.abs(item.offsetLeft + item.clientWidth / 2 - center);
        if (distance < shortest) {
          shortest = distance;
          nearest = index;
        }
      });

      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === nearest);
        dot.setAttribute('aria-current', index === nearest ? 'true' : 'false');
      });
    }

    // rAF-throttled: a scroll handler that runs layout reads on every event
    // is the classic way to make a snap carousel feel worse than no carousel.
    var queued = false;
    rail.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        syncDots();
      });
    });

    syncDots();
  });
});

/* ==========================================================================
   Scroll-driven behaviour — 2026-07-26 review pass
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll blur ----------
     Defocuses a section's background image as the section travels through the
     viewport, as on the reference page.

     Deliberately NOT scroll-linked per frame in the naive sense: the handler is
     rAF-throttled and writes a single custom property, and all layout reads for
     every blur section happen together before any write, so the loop cannot
     thrash layout. A blur filter on a full-bleed image is expensive enough that
     doing this carelessly is what makes a page feel like it is fighting the
     scroll wheel.

     Progress is 0 while the section's top is at the bottom of the viewport and
     1 by the time the section has scrolled most of the way up, so the image is
     sharp when the reader arrives and softest behind the copy. */

  var blurSections = Array.prototype.slice.call(document.querySelectorAll('[data-blur-scroll]'));

  if (blurSections.length && !reduceMotion) {
    var blurQueued = false;

    function paintBlur() {
      blurQueued = false;
      var viewportHeight = window.innerHeight;

      // Read every rect first, then write every property. Interleaving them
      // forces a synchronous layout per section.
      var measurements = blurSections.map(function (section) {
        return { section: section, rect: section.getBoundingClientRect() };
      });

      measurements.forEach(function (entry) {
        var rect = entry.rect;
        var max = Number(entry.section.getAttribute('data-blur-max')) || 14;

        // Distance travelled, as a fraction of the section's own scroll span.
        var span = rect.height + viewportHeight;
        var travelled = (viewportHeight - rect.top) / span;
        var progress = Math.min(Math.max(travelled, 0), 1);

        // Sharp on arrival, blurred as it leaves: ease past the first third so
        // the reader sees the photograph before it softens.
        var eased = Math.max(0, (progress - 0.3) / 0.7);

        entry.section.style.setProperty('--blur-amount', (eased * max).toFixed(2) + 'px');
      });
    }

    function queueBlur() {
      if (blurQueued) return;
      blurQueued = true;
      window.requestAnimationFrame(paintBlur);
    }

    window.addEventListener('scroll', queueBlur, { passive: true });
    window.addEventListener('resize', queueBlur);
    paintBlur();
  }

  /* ---------- Transparent header ----------
     The header sits over the hero as a translucent bar and only takes on a
     solid background once the page has scrolled past it. The class is toggled
     from a sentinel element at the top of the page rather than from a scroll
     position: an IntersectionObserver fires only on the crossing, where a
     scroll handler would run on every tick to answer the same question. */

  var header = document.querySelector('[data-site-header]');

  if (header && 'IntersectionObserver' in window) {
    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;pointer-events:none;';
    document.body.prepend(sentinel);

    new IntersectionObserver(
      function (entries) {
        header.classList.toggle('is-pinned', !entries[0].isIntersecting);
      },
      { threshold: 0 }
    ).observe(sentinel);
  }
});

/* ==========================================================================
   Scroll sequence — sections/petit-product-sequence.liquid
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  var sequences = Array.prototype.slice.call(document.querySelectorAll('[data-sequence]'));
  if (!sequences.length) return;

  // Under reduced motion the section stays in its unsequenced form: a plain
  // stack with every frame and caption visible. The class is what switches the
  // CSS into the pinned presentation, so not adding it is the whole opt-out.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.documentElement.classList.add('sequence-enabled');

  var instances = sequences.map(function (section) {
    return {
      section: section,
      track: section.querySelector('.sequence__track'),
      frames: Array.prototype.slice.call(section.querySelectorAll('[data-sequence-frame]')),
      captions: Array.prototype.slice.call(section.querySelectorAll('[data-sequence-caption]')),
      ticks: Array.prototype.slice.call(section.querySelectorAll('[data-sequence-tick]')),
      current: 0
    };
  });

  function setStep(instance, index) {
    // Every scroll tick asks for a step; only a change is worth touching the
    // DOM for. Without this guard the class writes run at scroll frequency.
    if (index === instance.current) return;
    instance.current = index;

    instance.frames.forEach(function (frame, i) {
      frame.classList.toggle('is-active', i === index);
    });

    instance.captions.forEach(function (caption, i) {
      caption.classList.toggle('is-active', i === index);
      // Hidden captions are stacked underneath the visible one, so they have to
      // leave the accessibility tree or a screen reader reads all of them.
      caption.setAttribute('aria-hidden', i === index ? 'false' : 'true');
    });

    instance.ticks.forEach(function (tick, i) {
      tick.classList.toggle('is-active', i === index);
    });
  }

  var queued = false;

  function paint() {
    queued = false;
    var viewportHeight = window.innerHeight;

    // Read every rect before writing any class, so a multi-instance page cannot
    // interleave layout reads with style writes.
    var measurements = instances.map(function (instance) {
      return { instance: instance, rect: instance.track.getBoundingClientRect() };
    });

    measurements.forEach(function (entry) {
      var instance = entry.instance;
      var rect = entry.rect;
      var steps = instance.frames.length;
      if (!steps) return;

      // The stage is pinned from the moment the track's top passes the top of
      // the viewport until its bottom arrives. Progress is where we are within
      // that pinned span, 0 to 1. The trailing viewport-height is the lead-in
      // reserved in CSS, so the last step holds on screen rather than flicking
      // past at the boundary.
      var pinnedSpan = rect.height - viewportHeight;
      var progress = pinnedSpan > 0 ? -rect.top / pinnedSpan : 0;
      progress = Math.min(Math.max(progress, 0), 1);

      // Multiplying by steps (not steps - 1) gives every step an equal share of
      // the scroll; the clamp catches progress === 1 landing out of range.
      var index = Math.min(Math.floor(progress * steps), steps - 1);

      setStep(instance, index);
    });
  }

  function queue() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(paint);
  }

  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  paint();
});

/* ==========================================================================
   Product page — gallery, lightbox, sticky bar (2026-07-27)
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  /* ---------- Gallery ----------
     Every image is already in the DOM and stacked; switching is a class toggle,
     not a src swap, so there is no reload flash when moving between views. */

  var gallery = document.querySelector('[data-gallery]');

  if (gallery) {
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var mains = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-main]'));

    var showImage = function (index) {
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
        thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      mains.forEach(function (main, i) {
        main.classList.toggle('is-active', i === index);
      });
    };

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () { showImage(index); });
    });

    document.addEventListener('variant:change', function (event) {
      var mediaId = event.detail && event.detail.mediaId;
      if (!mediaId) return;
      var index = mains.findIndex(function (main) {
        return String(main.getAttribute('data-media-id')) === String(mediaId);
      });

      if (index < 0 && event.detail && event.detail.title) {
        var selectedTitle = event.detail.title.toLowerCase();
        index = mains.findIndex(function (main) {
          var image = main.querySelector('img');
          return image && image.alt.toLowerCase().indexOf(selectedTitle) !== -1;
        });
      }
      if (index < 0) return;
      showImage(index);
      if (isTrack()) stage.scrollTo({ left: stage.clientWidth * index, behavior: 'smooth' });
    });

    /* ---------- Swipe (phone) ----------
       Below 750px the stage is a scroll-snap track rather than an opacity
       stack (see base.css), so the source of truth for "which image is showing"
       becomes scroll position, not a class. Both directions are wired:

         swipe  -> update the active thumbnail
         thumb  -> scroll the track to that slide

       The scroll handler is rAF-throttled because scroll fires far more often
       than the value it is being asked to derive can change, and a guard flag
       stops a programmatic scrollTo from feeding its own smooth-scroll frames
       back in as if the reader had swiped. */
    var stage = gallery.querySelector('.pdp__stage');
    var isTrack = function () {
      return stage && window.matchMedia('(max-width: 749px)').matches;
    };

    if (stage && mains.length > 1) {
      var ticking = false;
      var selfScrolling = null;

      stage.addEventListener(
        'scroll',
        function () {
          if (!isTrack() || selfScrolling !== null || ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            ticking = false;
            var index = Math.round(stage.scrollLeft / stage.clientWidth);
            index = Math.max(0, Math.min(mains.length - 1, index));
            thumbs.forEach(function (thumb, i) {
              thumb.classList.toggle('is-active', i === index);
              thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
            });
            // Keep the active thumbnail in view as the reader swipes past it.
            if (thumbs[index] && thumbs[index].scrollIntoView) {
              thumbs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
            }
          });
        },
        { passive: true }
      );

      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () {
          if (!isTrack()) return;
          window.clearTimeout(selfScrolling);
          selfScrolling = window.setTimeout(function () { selfScrolling = null; }, 420);
          stage.scrollTo({ left: stage.clientWidth * index, behavior: 'smooth' });
        });
      });
    }
  }

  /* ---------- Lightbox ----------
     Opened from the main image. Unlike the hotspot tooltips this DOES lock the
     body and trap Escape: it covers the viewport, so leaving the page scrollable
     underneath means closing it can land the reader somewhere else entirely. */

  var lightbox = document.querySelector('[data-lightbox]');

  if (lightbox) {
    var slides = Array.prototype.slice.call(lightbox.querySelectorAll('[data-lightbox-image]'));
    var opener = null;
    var index = 0;

    var render = function () {
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
    };

    var openLightbox = function (startIndex, trigger) {
      index = startIndex;
      opener = trigger || null;
      render();

      document.body.style.overflow = 'hidden';
      lightbox.hidden = false;

      // Laid out one frame before the class lands, so the fade has a start
      // value to animate from — same reason as the drawer.
      window.requestAnimationFrame(function () {
        lightbox.classList.add('is-open');
        var panel = lightbox.querySelector('.lightbox__panel');
        if (panel) panel.focus();
      });
    };

    var closeLightbox = function () {
      lightbox.classList.remove('is-open');
      document.body.style.overflow = '';

      window.setTimeout(function () {
        if (!lightbox.classList.contains('is-open')) lightbox.hidden = true;
      }, 260);

      // Focus goes back to the image that opened it, not the top of the page.
      if (opener) {
        opener.focus();
        opener = null;
      }
    };

    // Wraps in both directions: at the last image "next" returns to the first,
    // which is what a viewer flicking through a short set expects.
    var step = function (delta) {
      if (!slides.length) return;
      index = (index + delta + slides.length) % slides.length;
      render();
    };

    document.querySelectorAll('[data-lightbox-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openLightbox(Number(trigger.getAttribute('data-lightbox-open')) || 0, trigger);
      });
    });

    lightbox.querySelectorAll('[data-lightbox-close]').forEach(function (el) {
      el.addEventListener('click', closeLightbox);
    });

    var prev = lightbox.querySelector('[data-lightbox-prev]');
    var next = lightbox.querySelector('[data-lightbox-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    document.addEventListener('keydown', function (event) {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') step(-1);
      if (event.key === 'ArrowRight') step(1);
    });
  }

  /* ---------- Sticky add-to-cart ----------
     Shown once the real Add to cart leaves the viewport. This supersedes the
     older block that watched `.product-hero__cta`, an element that no longer
     exists after the PDP rebuild — the bar had silently stopped working. */

  var stickyBar = document.querySelector('[data-sticky-atc]');
  var atcAnchor = document.querySelector('[data-atc-anchor]');
  var heroSection = document.querySelector('.hero');

  if (stickyBar && atcAnchor && 'IntersectionObserver' in window) {
    var atcAnchorInView = true;
    var heroInView = !!heroSection;
    var updateStickyBar = function () {
      stickyBar.classList.toggle('is-visible', !atcAnchorInView && !heroInView);
    };

    new IntersectionObserver(
      function (entries) {
        atcAnchorInView = entries[0].isIntersecting;
        updateStickyBar();
      },
      { threshold: 0 }
    ).observe(atcAnchor);

    if (heroSection) {
      new IntersectionObserver(
        function (entries) {
          heroInView = entries[0].isIntersecting;
          updateStickyBar();
        },
        { threshold: 0 }
      ).observe(heroSection);
    }
  }
});

/* ==========================================================================
   Cart drawer — sections/cart-drawer.liquid  (2026-07-27)

   Every mutation follows the same shape: call the cart API, then re-render the
   drawer section server-side and swap its HTML in. Nothing about money, totals,
   discounts or currency is computed here — Liquid already does that correctly,
   and duplicating it in JS is how a storefront ends up showing a total the
   checkout disagrees with.

   The open state lives on <body>, not inside the drawer, precisely because the
   drawer's markup is replaced on every refresh. A class on a replaced element
   would be wiped mid-interaction.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-cart-root]');
  if (!root) return;

  var lastOpener = null;

  function openCart(opener) {
    if (opener) lastOpener = opener;
    /* The mobile menu is a separate panel with its own open state. Leaving it
       open behind the drawer means closing the cart drops the visitor back
       into a menu they never asked for. */
    var menuToggle = document.querySelector('[data-menu-toggle]');
    if (menuToggle) {
      document.body.classList.remove('menu-open');
      menuToggle.setAttribute('aria-expanded', 'false');
    }

    document.body.classList.add('cart-open');
    document.body.style.overflow = 'hidden';

    var drawer = root.querySelector('[data-cart-drawer]');
    if (drawer) drawer.setAttribute('aria-hidden', 'false');

    var panel = root.querySelector('[data-cart-panel]');
    if (panel) panel.focus();
  }

  function closeCart() {
    document.body.classList.remove('cart-open');
    document.body.style.overflow = '';

    var drawer = root.querySelector('[data-cart-drawer]');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');

    if (lastOpener) {
      lastOpener.focus();
      lastOpener = null;
    }
  }

  // Re-render from the Section Rendering API. Returns a promise so callers can
  // sequence "mutate, then refresh, then open".
  function refresh() {
    return fetch('/?sections=cart-drawer')
      .then(function (response) {
        if (!response.ok) throw new Error('Cart refresh failed: ' + response.status);
        return response.json();
      })
      .then(function (sections) {
        if (typeof sections['cart-drawer'] === 'string') {
          root.innerHTML = sections['cart-drawer'];
        }
        updateHeaderCount();
      });
  }

  // The header count sits outside the drawer, so it is updated separately
  // rather than being re-rendered with it.
  function updateHeaderCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cartLink = document.querySelector('.site-header__cart');
        if (!cartLink) return;

        var badge = cartLink.querySelector('.site-header__count');

        if (cart.item_count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'site-header__count';
            badge.setAttribute('aria-hidden', 'true');
            cartLink.appendChild(badge);
          }
          badge.textContent = cart.item_count;
        } else if (badge) {
          badge.remove();
        }
      })
      .catch(function () { /* A stale badge is not worth surfacing an error for. */ });
  }

  /* ---------- Add to cart ----------
     Only forms marked [data-cart-add] are intercepted. The buy-now snippet is
     deliberately left alone: its whole purpose is to skip the cart and land on
     checkout, so opening a drawer there would undo it. */

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-cart-add]');
    if (!form) return;

    event.preventDefault();

    var button = form.querySelector('button[type="submit"]');
    var original = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }

    /* Once /cart/add.js succeeds, the item is already in the cart. A later
       drawer-refresh failure must not submit the form again and add a second. */
    var addSucceeded = false;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
      body: new URLSearchParams(new FormData(form)).toString()
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (body) {
            throw new Error(body.description || 'Could not add to cart');
          });
        }
        addSucceeded = true;
        return response.json();
      })
      .then(function () {
        return refresh();
      })
      .then(function () {
        openCart(button);
      })
      .catch(function (error) {
        // A full form post is safe only when the original cart add failed.
        console.error('[cart]', error);
        if (!addSucceeded) {
          form.removeAttribute('data-cart-add');
          form.submit();
        }
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.textContent = original;
        }
      });
  });

  /* ---------- Quantity, remove, attributes ----------
     Delegated from the root, because the drawer's contents are replaced on
     every refresh and directly-bound handlers would be lost with them. */

  root.addEventListener('click', function (event) {
    var closer = event.target.closest('[data-cart-close]');
    if (closer) {
      // Let a link inside the empty state navigate rather than only closing.
      if (closer.tagName !== 'A') event.preventDefault();
      closeCart();
      return;
    }

    var stepper = event.target.closest('[data-cart-change]');
    if (!stepper) return;

    var line = stepper.getAttribute('data-cart-change');
    var quantity = stepper.getAttribute('data-cart-qty');

    stepper.disabled = true;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Could not update the cart');
        return refresh();
      })
      .catch(function (error) {
        console.error('[cart]', error);
        stepper.disabled = false;
      });
  });

  root.addEventListener('change', function (event) {
    var toggle = event.target.closest('[data-cart-attribute]');
    if (!toggle) return;

    var name = toggle.getAttribute('data-cart-attribute');
    var attributes = {};
    attributes[name] = toggle.checked ? 'Yes' : '';

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Could not update cart attributes');
        return refresh();
      })
      .catch(function (error) { console.error('[cart]', error); });
  });

  /* ---------- Openers ---------- */

  /* Delegated from the document, and the drawer is opened BEFORE the refresh
     rather than after it.

     The old order tied opening to a network round-trip: preventDefault stopped
     the link to /cart, then a single un-caught fetch failure left nothing to
     open the drawer, so a tap on a flaky mobile connection did nothing at all
     and looked like a dead button. Opening first means the tap always lands;
     the refresh only updates what is inside a drawer that is already on screen.

     Delegation also survives the drawer markup being replaced on every
     refresh, and covers any opener added to the page later. */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cart-open]');
    if (!trigger) return;

    event.preventDefault();
    openCart(trigger);
    refresh().catch(function (error) { console.error('[cart]', error); });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && document.body.classList.contains('cart-open')) closeCart();
  });
});

/* ==========================================================================
   Variant sync — sections/main-product.liquid  (2026-07-27)

   Found during review: the variant buttons wrote the chosen id into the form
   (the older [data-variant-picker] handler does that) but nothing updated the
   visible price or the selected-option label. Both Rebire variants are the same
   price today, so it looked correct — it would have started lying silently the
   first time the two prices diverged.

   Prices come from the JSON emitted by Liquid, already formatted, so no money
   formatting happens here.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  var dataTag = document.querySelector('[data-variant-json]');
  var picker = document.querySelector('[data-variant-picker]');
  if (!dataTag || !picker) return;

  var variants;
  try {
    variants = JSON.parse(dataTag.textContent);
  } catch (error) {
    // A malformed payload must not take out the add-to-cart button below it.
    console.error('[variant]', error);
    return;
  }

  var priceEl = document.querySelector('.pdp__price-current');
  var wasEl = document.querySelector('.pdp__price-was');
  var saveEl = document.querySelector('[data-sale-save]');
  var saveAmountEl = document.querySelector('[data-sale-savings]');
  var atcPriceEl = document.querySelector('[data-atc-price]');
  var badgeEl = document.querySelector('[data-sale-badge]');
  var labelEl = document.querySelector('.pdp__variant-current');
  var atc = document.querySelector('.pdp__atc');
  var atcLabel = atc ? atc.textContent.trim() : '';

  picker.addEventListener('click', function (event) {
    var button = event.target.closest('[data-variant-option]');
    if (!button) return;

    var id = Number(button.getAttribute('data-variant-id'));
    var variant = variants.filter(function (v) { return v.id === id; })[0];
    if (!variant) return;

    if (priceEl) priceEl.textContent = variant.price;
    if (labelEl) labelEl.textContent = variant.title;

    // Only show a compare-at price when there is one; Liquid renders that
    // element only if it was higher on load, so guard for its absence.
    if (wasEl) {
      wasEl.textContent = variant.compare_at || '';
      wasEl.hidden = !variant.compare_at;
    }

    // Same contract as the compare-at price above: a variant with no saving
    // hides the badge rather than showing "You save $0.00". Older markup
    // without the element, or a payload without the key, simply no-ops.
    if (atcPriceEl && variant.price) atcPriceEl.textContent = variant.price;

    if (badgeEl) {
      badgeEl.textContent = variant.pct_off ? '-' + variant.pct_off + '%' : '';
      badgeEl.hidden = !variant.pct_off;
    }

    if (saveEl) {
      if (variant.savings) {
        if (saveAmountEl) saveAmountEl.textContent = variant.savings;
        saveEl.hidden = false;
      } else {
        saveEl.hidden = true;
      }
    }

    if (atc) {
      atc.disabled = !variant.available;
      atc.textContent = variant.available ? atcLabel : 'Sold out';
    }

    document.dispatchEvent(new CustomEvent('variant:change', {
      detail: {
        mediaId: button.getAttribute('data-variant-media-id'),
        title: variant.title
      }
    }));

    // Variants are not linked to featured media in Shopify Admin, so use the
    // colour named in each image alt as a reliable gallery fallback.
    var galleryMains = Array.prototype.slice.call(document.querySelectorAll('[data-gallery-main]'));
    var galleryIndex = galleryMains.findIndex(function (main) {
      var image = main.querySelector('img');
      return image && image.alt.toLowerCase().indexOf(variant.title.toLowerCase()) !== -1;
    });

    if (galleryIndex >= 0) {
      galleryMains.forEach(function (main, index) {
        main.classList.toggle('is-active', index === galleryIndex);
      });
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb, index) {
        thumb.classList.toggle('is-active', index === galleryIndex);
        thumb.setAttribute('aria-current', index === galleryIndex ? 'true' : 'false');
      });
    }

    // Keeps the URL shareable and the back button meaningful.
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  });
});

/* ==========================================================================
   Mobile menu — sections/header.liquid  (2026-07-27)

   The panel is revealed rather than built, and the header keeps its inline nav
   in the DOM at all widths: CSS hides whichever presentation does not apply, so
   nothing has to be relocated between breakpoints and exactly one copy of the
   links is ever exposed to assistive tech.

   Open state lives on <body> so the fixed header and the fixed panel can both
   respond to it without either being an ancestor of the other.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-menu-toggle]');
  var panel = document.querySelector('[data-menu-panel]');
  if (!toggle || !panel) return;

  function closeMenu() {
    document.body.classList.remove('menu-open');
    toggle.setAttribute('aria-expanded', 'false');
  }

  toggle.addEventListener('click', function () {
    var isOpen = document.body.classList.toggle('menu-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  // Following a link inside the panel navigates; the class would otherwise
  // survive into the next page via a cached back-navigation.
  panel.addEventListener('click', function (event) {
    if (event.target.closest('a')) closeMenu();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeMenu();
  });

  // Crossing the breakpoint while open would leave the burger in its cross
  // state with the inline nav showing.
  window.matchMedia('(min-width: 700px)').addEventListener('change', function (event) {
    if (event.matches) closeMenu();
  });
});


/* How-it-works clips ------------------------------------------------------
   The source is assigned here rather than in the markup so a phone never
   downloads the 5.4 MB desktop cut. Playback starts only while the panel is on
   screen, and never under reduced motion — the clip is decorative, so the
   poster frame is a complete fallback. */
(function () {
  var vids = document.querySelectorAll('[data-hiw-video]');
  if (!vids.length) return;

  var wantsMobile = window.matchMedia('(max-width: 749px)').matches;
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  Array.prototype.forEach.call(vids, function (v) {
    var src = (wantsMobile && v.getAttribute('data-src-mobile')) || v.getAttribute('data-src');
    if (!src) return;
    v.src = src;

    if (still || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var p = e.target.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          e.target.pause();
        }
      });
    }, { threshold: 0.35 }).observe(v);
  });
})();


/* ---------- Delivery estimate ----------
   Turns the server-rendered fallback sentence into dated Ordered/Shipped/
   Delivered steps plus a live countdown to the same-day dispatch cutoff.

   All arithmetic happens on the SHOP's calendar (America/New_York), not the
   visitor's, because the cutoff being counted down to is a fact about the
   warehouse, not about where the shopper is standing. A visitor in Vancouver
   and one in Halifax must see the same deadline.

   Dates are carried as UTC-noon Date objects: only the calendar date matters
   here, and noon keeps a day from slipping either side of a DST boundary. */
(function () {
  var root = document.querySelector('[data-delivery]');
  if (!root || typeof Intl === 'undefined' || !Intl.DateTimeFormat) return;

  var TZ = 'America/New_York';
  var cutoffHour = parseInt(root.getAttribute('data-cutoff-hour'), 10);
  var minDays = parseInt(root.getAttribute('data-min-days'), 10);
  var maxDays = parseInt(root.getAttribute('data-max-days'), 10);
  if (isNaN(cutoffHour) || isNaN(minDays) || isNaN(maxDays)) return;

  var lead = root.querySelector('[data-delivery-lead]');
  var steps = root.querySelector('[data-delivery-steps]');
  var shippedEl = root.querySelector('[data-step-shipped]');
  var deliveredEl = root.querySelector('[data-step-delivered]');

  function shopParts() {
    var parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    // Hour 24 appears at midnight in some engines; normalise it to 0.
    var hour = parseInt(parts.hour, 10) % 24;
    return {
      date: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day, 12)),
      hour: hour,
      minute: parseInt(parts.minute, 10),
      second: parseInt(parts.second, 10)
    };
  }

  function isWeekend(d) { var g = d.getUTCDay(); return g === 0 || g === 6; }

  function addBusinessDays(from, n) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < n) {
      d.setUTCDate(d.getUTCDate() + 1);
      if (!isWeekend(d)) added++;
    }
    return d;
  }

  function addCalendarDays(from, n) {
    var d = new Date(from.getTime());
    d.setUTCDate(d.getUTCDate() + n);
    return d;
  }

  function nextBusinessDay(from) {
    var d = new Date(from.getTime());
    do { d.setUTCDate(d.getUTCDate() + 1); } while (isWeekend(d));
    return d;
  }

  var fmtShort = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric' });
  var fmtDay = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'long' });

  function render() {
    var now = shopParts();
    var shipsToday = !isWeekend(now.date) && now.hour < cutoffHour;
    var ship = shipsToday ? now.date : nextBusinessDay(now.date);

    // Dispatch follows business days because the warehouse is shut at weekends;
    // transit does not, because a parcel keeps moving on a Saturday. Using
    // business days for both stretched a 4-5 day window across a weekend and
    // quoted "Sep 4 - Sep 7", which reads as vaguer than the estimate is.
    var from = addCalendarDays(ship, minDays);
    var to = addCalendarDays(ship, maxDays);

    if (shippedEl) shippedEl.textContent = shipsToday ? 'Today' : fmtShort.format(ship);
    if (deliveredEl) deliveredEl.textContent = fmtShort.format(from) + ' – ' + fmtShort.format(to);
    if (steps) steps.hidden = false;

    // The stock line's dispatch clause comes from this same computation, so the
    // two can never disagree about whether "today" is still on the table.
    var dispatchEl = document.querySelector('[data-stock-dispatch]');
    if (dispatchEl) {
      dispatchEl.textContent = shipsToday
        ? ' — ships today if you order before ' + (root.getAttribute('data-cutoff-label') || 'the cutoff')
        : ' — ships ' + fmtDay.format(ship);
    }

    if (!lead) return true;

    if (shipsToday) {
      var left = (cutoffHour * 3600) - (now.hour * 3600 + now.minute * 60 + now.second);
      if (left <= 0) return false;
      var h = Math.floor(left / 3600);
      var m = Math.floor((left % 3600) / 60);
      var within = h > 0 ? h + ' hr ' + m + ' min' : m + ' min';
      lead.innerHTML = 'Order within <strong>' + within + '</strong> to ship today.';
      lead.hidden = false;
    } else {
      // Nothing to add: the Shipped column already names the day.
      lead.hidden = true;
    }
    return true;
  }

  if (render()) {
    // Re-render each minute so the countdown ticks and rolls over correctly at
    // the cutoff; render() returning false means the cutoff just passed, so we
    // recompute immediately to move the estimate to the next business day.
    setInterval(function () { if (!render()) render(); }, 60000);
  } else {
    render();
  }
})();


/* ---------- Buy now ----------
   Adds the selected variant and goes straight to checkout, skipping the drawer.
   The variant id is read from the form at click time rather than captured on
   load, so it follows the colour picker. On any failure it falls back to the
   cart page instead of stranding the shopper on a dead button. */
(function () {
  var button = document.querySelector('[data-buy-now]');
  if (!button) return;

  var form = button.closest('form');
  if (!form) return;

  button.addEventListener('click', function () {
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;

    var label = button.textContent;
    button.disabled = true;
    button.textContent = 'One moment…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        window.location.href = '/checkout';
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = label;
        window.location.href = '/cart';
      });
  });
})();
